const UtilitySVG =({x,y, handler,configData, uiData })=>{
  return (
    <g id="utility">
    <svg
      x={x}
      y={y}
      width="195px"
      height="130px"
      viewBox="0 0 10 149"
      onClick={handler}
    >
      <title>{configData?.name}</title>
      <g
        id="Design"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Design/Assets-_-00"
          transform="translate(-604.000000, -372.000000)"
        >
          <g
            id="SLD/Production/Uniline/Undefined"
            transform="translate(604.000000, 372.000000)"
          >
            <g id="SLD/Production/Uniline/Tobedefine">
              <g id="Group-7">
                <rect
                  id="Rectangle"
                  x="0"
                  y="0"
                  width="96"
                  height="144"
                ></rect>
                <line
                  x1="48.5"
                  y1="96"
                  x2="48.5"
                  y2="144"
                  id="Line-2"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  stroke={uiData.configured ? "var(--se-sld-circline)" : "#E47F00"}
                ></line>
                <circle
                  id="Oval"
                  style={uiData.selected ? {} : { display: "none" }}
                  stroke="#42B4E6"
                  strokeWidth="3"
                  cx="48"
                  cy="56"
                  r="55"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="rgba(0, 135, 205, 0.2)"
                ></circle>
                <circle
                  id="Oval"
                  strokeWidth="3"
                  fill="var(--se-background-alternative)"
                  cx="48"
                  cy="56"
                  r="46.5"
                  stroke={uiData.configured ? "var(--se-sld-circline)" : "#E47F00"}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></circle>
                <text
                  id="segment_energy_infra"
                  fontFamily="se-icon"
                  fontSize="56"
                  fontWeight="normal"
                  fill="var(--se-sld-circline)"
                >
                  <tspan x="20" y="76">
                    segment_energy_infrastructure
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </g>
  );
}
export default UtilitySVG;